import { COLLECT_REPORT } from '@/api/index'
import common from '@/utils/common'
export default {
  viewType: 'form',
  module: COLLECT_REPORT,
  customCbAction: function() {},
  callBackAction: 'EnvCollectReportSuccess',
  okAction: 'import',
  view: {
    title: 'pocMng.uploadCollectReport',
    content: [
      {
        $id: 'fileName',
        $type: 'upload-file',
        label: 'pocMng.envCollectReport',
        rules: [
          { notEmpty: { message: 'pocMng.envCollectReportNotEmpty' } },
          { checkFileNameLength: 200 },
          { fileSize: { min: 1 } },
          {
            suffix: {
              includeSuffixes: ['zip'],
              errorMessage: '请选择包含采集报告的zip格式的文件进行上传'
            }
          },
          {
            customValidate: {
              validate(validateOther, form, curFormItem) {
                let validator = (rule, val, callback) => {
                  let size = val.size
                  if (size > common.fileSizeMax) {
                    callback(new Error('不能超过最大文件上传30M限制'))
                  } else {
                    callback()
                  }
                }
                return {
                  validator
                }
              }
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      },
      {
        $id: 'uploadDes',
        $type: 'sky-alert-description',
        $el: {
          label: 'pocMng.collectImport',
          hasList: true,
          type: 'warning'
        }
      }
    ]
  }
}
